import { AccordionSection } from './AccordionSection/AccordionSection'
import { AuthSection } from '@dtx-company/app/shared/code/src/components/LoggedOutCodeGeneratorV2/GeneratorSections/AuthSection/AuthSection'
import { Box, Chip, Stack, Typography } from '@dtx-company/design-system/src'
import { CodePreview } from '@dtx-company/app/shared/code/src/components/LoggedOutCodeGeneratorV2/CodePreview/CodePreview'
import { FC } from 'react'
import { useAccordionLOCG } from './hooks/useAccordionLOCG'
import AllInclusiveIcon from '@mui/icons-material/AllInclusive'
import useTranslation from 'next-translate/useTranslation'

export const AccordionLOCGenerator: FC = () => {
  const { expanded, onSubmitError, onAccordionChange, selectedScanDestinationType } =
    useAccordionLOCG()
  const { t } = useTranslation('logged-out-generator')

  return (
    <Stack gap={4}>
      <Stack direction={'row'} justifyContent={'space-between'} sx={{ my: 2 }}>
        <Typography
          component="h1"
          variant={{ xs: 'subtitleMedium', md: 'headlineMedium', lg: 'headlineLarge' }}
          data-testid="desktop-title"
        >
          {t('Header.title')}
        </Typography>
        <Chip
          component="a"
          href={
            'https://support.flowcode.com/is-flowcode-qr-free-is-there-a-scan-limit-go-to-flowcode'
          }
          target="_blank"
          variant="outlined"
          startIcon={AllInclusiveIcon}
          label={t('Header.chip')}
          data-testid="heading-chip"
          data-heap-id="LoggedOutGenerator_Heading_MarketingChip"
          aria-label={t('LoggedOutGenerator.MarketingChip.ariaLabel', {
            text: t('Header.chip')
          })}
        />
      </Stack>
      <Stack
        sx={theme => ({
          display: 'grid',
          gridTemplateColumns: { sx: '1fr', md: '5fr 6fr' },
          gap: '133px',
          position: 'relative',
          overflowY: 'hidden',
          height: `auto`,
          width: '100%',
          gridTemplateRows: `minmax(${theme.spacing(150)}, 65vh)`,
          p: 2
        })}
      >
        <Stack sx={{ height: '100%', overflowY: 'auto' }}>
          <AccordionSection
            expanded={expanded}
            onAccordionChange={onAccordionChange}
            selectedScanDestinationType={selectedScanDestinationType}
          />
        </Stack>
        <Stack
          gap={2}
          sx={{ display: 'grid', gridTemplateRows: '1fr max-content ', position: 'relative' }}
        >
          <CodePreview accordionPreviewStyle />
          <Box>
            <AuthSection hideBackButton onSubmitError={onSubmitError} />
          </Box>
        </Stack>
      </Stack>
    </Stack>
  )
}
